// Icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DrawIcon from "@mui/icons-material/Draw";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import { ReactComponent as Sites } from "../GlobalAssets/svg/Sites.svg";
import { ReactComponent as Sitesfull } from "../GlobalAssets/svg/Sitesfill.svg";
import { ReactComponent as CreateSiteSvg } from "../GlobalAssets/svg/CreateSite.svg";
import { ReactComponent as CreateSiteFull } from "../GlobalAssets/svg/CreateSiteFull.svg";

// Routes configuration
export const privateRoutesList = [
  {
    path: "/account/:orgId",
    subPath: "dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: null, // Will be populated by routes.js
    layout: "/account/dashboard",
    subRoutes: [
      {
        path: "team-members",
        name: "Team Members",
        component: null,
      },
      {
        path: "client-organizations",
        name: "Client Organizations",
        component: null,
      },
      {
        path: "settings",
        name: "Settings",
        component: null,
      },
    ],
  },
  {
    path: "/account/:orgId",
    subPath: "create",
    name: "Create Site",
    icon: CreateSiteFull,
    outlinedIcon: CreateSiteSvg,
    component: null,
    layout: "/account/site",
  },
  {
    path: "/account/:orgId",
    subPath: "sites-overview",
    name: "Sites",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: null,
    layout: "/account/websites",
    subRoutes: [
      {
        path: ":siteId/site-details",
        name: "Site Details",
        component: null,
      },
      {
        path: ":siteId/domains-hosted",
        name: "Domain Hosted",
        component: null,
      },
      {
        path: ":siteId/backups-restores",
        name: "Backups & Restore",
        component: null,
      },
      {
        path: ":siteId/dev-tools",
        name: "Dev Tools",
        component: null,
      },
      {
        path: ":siteId/file-explorer",
        name: "File Explorer",
        component: null,
      },
      {
        path: ":siteId/alerts",
        name: "Alerts",
        component: null,
      },
      {
        path: ":siteId/site-addons",
        name: "Add-ons",
        component: null,
      },
      {
        path: ":siteId/site-migration",
        name: "Site Migration",
        component: null,
      },
    ],
  },
  {
    path: "/account/:orgId",
    subPath: "blueprints",
    name: "Blueprint",
    icon: DrawIcon,
    outlinedIcon: DrawOutlinedIcon,
    component: null,
    layout: "/account/blueprint",
  },
  {
    path: "/account/:orgId",
    subPath: "billing-overview",
    name: "Billing",
    icon: PaidIcon,
    outlinedIcon: PaidOutlinedIcon,
    component: null,
    layout: "/account/plans",
    subRoutes: [
      {
        path: "plan-usage",
        name: "Plan Usage",
        component: null,
      },
      {
        path: "modify-plan",
        name: "Modify Plan",
        component: null,
      },
      {
        path: "add-on",
        name: "Add-ons",
        component: null,
      },
    ],
  },
];
